import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { GenderItem } from 'features/genders/types/genders.types'

type EditGenderVariables = {
	id: number
	data: Pick<GenderItem, 'name'>
}

type UseEditGenderMutationProps = {
	onSuccess: () => void
}

export const useEditGenderMutation = ({ onSuccess }: UseEditGenderMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editGenderMutation, isPending: isEditGenderLoading } = useMutation({
		mutationFn: ({ id, data }: EditGenderVariables) => {
			return axiosPrivate.patch(apiRoutes.gender(String(id)), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.genders.all })
			useToast({ type: 'success', message: t('Gender edited') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editGenderMutation,
		isEditGenderLoading
	}
}
